<script lang="ts">
  import { IntersectionObserver } from "@opera-gx/components/v6";
  // prettier-ignore
  import { fade } from "svelte/transition";

  import MobileDailySection from "../components/DailySection/MobileDailySection.svelte";

  export let items;
  export let section_title: string;
  export let key = "";
  let wrapper: HTMLElement;
</script>

<section id={key !== "" ? `gx-section_${key}` : null} class="flex flex-col gap-4">
  <h2
    transition:fade
    class="pl-left pr-right mb-4 text-lg font-semibold"
    style="color: hsl(var(--color-gxm-text-on-wallpaper));">
    {section_title}
  </h2>
  <div transition:fade bind:this={wrapper}>
    {#if wrapper}
      <IntersectionObserver once root={wrapper} margin="0px 600px" let:intersecting>
        {#if items.length > 0}
          <div class="flex justify-center">
            {#if intersecting}
              <MobileDailySection data={items} />
            {/if}
          </div>
        {/if}
      </IntersectionObserver>
    {/if}
  </div>
</section>
